import request from "../infra/request";

export const getEmailNotifications = async (endAt) => {
  const response = await request.get("/admin/email-notifications", { params: { endAt } });
  return response.data.emailNotifications;
};
